import React from 'react';
import './Syncindicator.css';

interface SyncIndicatorProps {
    pendingSyncs: string[];
    syncing: boolean;
}

export function SyncIndicator({ pendingSyncs, syncing }: SyncIndicatorProps) {
    if (pendingSyncs.length === 0 && !syncing) {
        return null; // Nothing to show
    }

    return (
        <div className="sync-indicator">
            <div className="sync-spinner" />
            <span className="sync-text">
                {syncing
                    ? 'Syncing changes...'
                    : `${pendingSyncs.length} change${pendingSyncs.length === 1 ? '' : 's'} pending`
                }
            </span>
        </div>
    );
}